import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import {
  zodInsertPromoCode,
  zodSelectPromoCode,
  zodSelectPromoCodeRecurring,
  zodSelectPromoPrizeReward,
} from '../generated/zodSchemas.generated';

import {
  PromoAction,
  PromoStatus,
  PromoType,
  RewardType,
} from '@daymade/common-lib/dbEnums';
import { ZPromoConditions } from '@daymade/common-lib/dbJsonModels';
import { z } from 'zod';

export type TPromoStatus = PromoStatus;

export type TPromoType = PromoType;

export type TPromoAction = PromoAction;

export type TPromoRewardType = RewardType;
export const PromoRewardType = RewardType;

const ZMonthlyUsage = z.object({
  month: z.coerce.date(),
  count: z.number(),
});
export type TMonthlyUsage = z.infer<typeof ZMonthlyUsage>;

export const ZPromoCodeSelect = zodSelectPromoCode.extend(
  ensureSubsetOfKeys(zodSelectPromoCode.shape, {
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    expiresAt: z.coerce.date().nullable(),
    conditions: ZPromoConditions.partial().optional().nullable(),
  }),
);
export type TPromoCodeSelect = z.infer<typeof ZPromoCodeSelect>;

export const ZPromoCodeWithUsage = ZPromoCodeSelect.extend({
  usage: ZMonthlyUsage.array(),
});
export type TPromoCodeWithUsage = z.infer<typeof ZPromoCodeWithUsage>;

export const ZPromoCodeInsert = zodInsertPromoCode
  .pick({
    code: true,
    status: true,
    description: true,
    banner: true,
    promoType: true,
    action: true,
    rewardType: true,
    rewardValue: true,
    rewardCount: true,
  })
  .extend(
    ensureSubsetOfKeys(zodInsertPromoCode.shape, {
      allowMulti: z.boolean().default(false),
      playerSpecific: z.boolean().default(false),
      conditions: ZPromoConditions.partial().optional(),
      expiresAt: z.coerce.date().optional().nullable(),
    }),
  );
export type TPromoCodeInsert = z.infer<typeof ZPromoCodeInsert>;

export const ZPromoCodeRecurringSelect = zodSelectPromoCodeRecurring
  .pick({
    id: true,
    status: true,
    createdAt: true,
    subscriptionId: true,
    remainingCount: true,
  })
  .extend(
    ensureSubsetOfKeys(zodInsertPromoCode.shape, {
      createdAt: z.coerce.date(),
    }),
  );

export type TPromoCodeRecurringSelect = z.infer<
  typeof ZPromoCodeRecurringSelect
>;

export const ZPromoPrizeRewardSelect = zodSelectPromoPrizeReward
  .pick({
    id: true,
    code: true,
    playerId: true,
    status: true,
    prizeId: true,
  })
  .extend(
    ensureSubsetOfKeys(zodSelectPromoPrizeReward.shape, {
      createdAt: z.coerce.date(),
      expiresAt: z.coerce.date().nullable(),
      chosenAt: z.coerce.date().nullable(),
    }),
  );

export type TPromoPrizeRewardSelect = z.infer<typeof ZPromoPrizeRewardSelect>;
